import type { SearchSuggestionItem } from '../search.types';

export function getSearchSuggestionAssistName(item: SearchSuggestionItem) {
    return item.kind === 'recent' ? 'recent searches' : 'popular searches';
}
